export default "__VITE_ASSET__X2Vc9Jsd__"